import React from "react";
import { Button, Select } from "antd";
import "./FilterSelect.scss";

const { Option } = Select;

function FilterButton({ text, onClick, selected }: { text: string; selected: boolean; onClick: () => void }) {
  return (
    <Button style={{ margin: "0 8px 8px 0" }} type={selected ? "primary" : "default"} onClick={onClick}>
      {text}
    </Button>
  );
}

type Props = {
  values: { id: string; text: string }[];
  label: string;
  selected: string[];
  onChange: (x: string[]) => void;
  loading: boolean;
};

function FilterSelect({ values, label, selected, onChange, loading }: Props) {
  const onButtonClick = (selectedId: string) => {
    if (selected.includes(selectedId)) {
      onChange(selected.filter((id) => selectedId !== id));
    } else {
      onChange([...selected, selectedId]);
    }
  };

  return (
    <div className="filter-select-item">
      <h5>{label}</h5>
      {values.length > 10 ? (
        <>
          {selected.map((id) => (
            <FilterButton key={id} text={id} onClick={() => onButtonClick(id)} selected />
          ))}
          <Select mode="tags" value={selected} onChange={onChange} size="large" loading={loading}>
            {values.map(({ id, text }) => (
              <Option key={id} value={id}>
                {text}
              </Option>
            ))}
          </Select>
        </>
      ) : (
        values.map(({ id, text }) => (
          <FilterButton selected={selected.includes(id)} key={id} onClick={() => onButtonClick(id)} text={text} />
        ))
      )}
    </div>
  );
}

export default FilterSelect;
